import React, { FC, useEffect, useState } from 'react';
import './CalendarFilter.css';
import { CalendarRow, Resource } from '../../Widgets/CalendarWidget/CalendarWidget';

interface CalendarFilterProps {
	filterByKey?: keyof CalendarRow;
	eventsData: CalendarRow[];
	resources?: Resource[];
	onFilterChange: (rows: CalendarRow[]) => void;
}

const CalendarFilter: FC<CalendarFilterProps> = ({ eventsData, filterByKey, onFilterChange, resources = [] }) => {

	const [selectedFilterValue, setSelectedFilterValue] = useState<string | number | 'all'>('all');
	const allFilterValues = filterByKey ? Array.from(new Set(eventsData.map(e => e[filterByKey]).filter(Boolean))) : [];

	useEffect(() => {

		const filteredEvents = filterByKey
			? eventsData.filter(e =>
				selectedFilterValue === 'all' ? true : String(e[filterByKey].id) === String(selectedFilterValue)
			)
			: eventsData;

		onFilterChange(filteredEvents);

	}, [selectedFilterValue]);

	if (!filterByKey) return null;

	const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const value = e.target.value;
		setSelectedFilterValue(value);
	};

	return (
		<div className="CalendarFilter" data-testid="CalendarFilter">

			<label htmlFor="filter-select">Filtrer : </label>
			<select id="filter-select" onChange={handleFilterChange} value={selectedFilterValue}>
				<option value="all">Tous</option>
				{allFilterValues.map((val) => (
					<option key={val.id} value={val.id}>
						{resources.find(r => r.key === val)?.title ?? `${(val.lastname as string).toUpperCase()} ${val.firstname}`}
					</option>
				))}
			</select>
		</div>
	);
}

export default CalendarFilter;
